const root = "/Storage";
const detail = `/:key`;

const StorageRoutes = {
  root,
  detail,
};

export default StorageRoutes;
